import { useSelector } from 'react-redux';
import {
  subscriptionTypeSelector,
  subscriptionPackageSelector,
} from '../../redux/mySubscription/mySubscription.selectors';

const useSubscriptionFlowAnalyticsParams = () => {
  const { language, subscriptionType, subscriptionPackage } = useSelector(
    (state) => ({
      language: state.ascendon.settings.language,
      subscriptionType: subscriptionTypeSelector(state),
      subscriptionPackage: subscriptionPackageSelector(state),
    }),
  );

  return [language, subscriptionType, subscriptionPackage];
};

export default useSubscriptionFlowAnalyticsParams;
